import { render, staticRenderFns } from "./Direction.vue?vue&type=template&id=6b8365a5&scoped=true&"
import script from "./Direction.vue?vue&type=script&lang=js&"
export * from "./Direction.vue?vue&type=script&lang=js&"
import style0 from "./Direction.vue?vue&type=style&index=0&id=6b8365a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8365a5",
  null
  
)

export default component.exports